
























import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { getCurrencyCode, getCurrencySymbol } from "@/lib/moneyHelpers";
import { INPUT_PROPS } from "@/const";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "InputMoney",
  components: { BaseInput },
  props: {
    ...INPUT_PROPS,
  },
  setup() {
    const currencySymbol = $t(getCurrencySymbol(getCurrencyCode()));

    return {
      currencySymbol,
    };
  },
});
